<template>
  <div class="content">
    <img class="banner" :src="state.aboutlist.banner?.full_img" alt="" />
    <!-- <div
      class="banner"
      :key="state.banner"
      :style="`background-image:url(${state.banner}?t=${Date.now()})`"
    ></div> -->
  </div>
  <div class="about">
    <div class="thehome">
      <span @click="topath('/')">{{ $t("header.home") }}</span> &nbsp;/
    </div>
    <div v-for="(item, index) in state.aboutlist.details" :key="index">
      <div class="title">
        <div
          class="one animate__animated animate__backInLeft"
          v-show="index !== 1 || state.d2"
        >
          {{ (locale == "zh" && item.title) || item.en_title }}
        </div>
        <div
          class="detail animate__animated animate__backInUp"
          style="text-align: justify"
          v-show="index !== 1 || state.d2"
        >
          {{ (locale == "zh" && item.content) || item.en_content }}
        </div>
      </div>
    </div>

    <div v-show="index !== 1 || state.d3">
      <div class="title">
        <!--           v-show="index !== 1 || state.d2" -->
        <!-- animate__animated animate__backInLeft -->
        <div
          class="one two animate__animated animate__backInLeft"
          v-if="state.aboutlist1.length"
        >
          {{
            (locale == "zh" && "什么是ACM SIGGRAPH?") || "What is ACM SIGGRAPH?"
          }}
        </div>
        <!--  v-show="index !== 1 || state.d2" -->
        <div
          class="detail animate__animated animate__backInUp"
          v-if="state.aboutlist1.length"
        >
          <div v-for="(item, index) in state.aboutlist1" :key="index">
            <div class="ACMtitle">
              # {{ (locale == "zh" && item.title) || item.en_title }}
            </div>
            <div class="ACMdetail">
              <div class="uleft">
                {{ (locale == "zh" && item.utitle) || item.en_utitle }}
              </div>
              <div class="uimg">
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <!-- {{ (locale == "zh" && "") || "" }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import { getaboutus } from "@/api/type";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { useRouter } from "vue-router";
const router = useRouter();
const state = reactive({
  d1: false,
  d2: false,
  d3: false,
  t1: false,
  t2: false,
  aboutlist: [],
  aboutlist1: [],
  banner: "",
});
const { data } = getaboutus().then((res) => {
  state.aboutlist = res.data;
  state.banner = res.data.banner.full_img;
  // state.aboutlist.banner.full_img =
});
const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  // console.log(scrollY, 989898);
  if (scrollY > 100) {
    state.d2 = true;
    state.t2 = true;
  }
  if (scrollY > 400) {
    state.d3 = true;
    // state.t2 = true;
  }
};
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  setTimeout(() => {
    state.aboutlist1 = [
      {
        img: "http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241213/ACM.svg",
        title: "ACM 国际计算机学会",
        en_title: "ACM International Computer Society",
        en_utitle:
          "ACM is the world's largest professional academic organization in the field of computer, founded in 1947, is the world's first scientific and educational computer society, currently in more than 130 countries and regions around the world has more than 100,000 members. ACM brings together international computer educators, researchers, industry, and students in a Special Interest Group (SIGs). Worldwide lectures and talks are also held every year around the world (but mainly in the United States) for members to share their research results.",
        utitle:
          "ACM是世界上最大的计算机领域专业性学术组织，创立于1947年，是世界上第一个科学性及教育性计算机学会，目前在全世界130多个国家和地区拥有超过10万名的会员。ACM汇集了国际计算机领域教育家，研究人员，工业界人士及学生，兴趣小组SIGs (Special Interest Group)。每年亦会在全世界（但主要在美国）举办世界性讲座及会谈，以供各会员分享他们的研究成果。",
      },
      {
        img: "http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241213/siggraph.svg",
        en_title: "SIGGRAPH Special Interest Group on Computer Graphics Images",
        title: "SIGGRAPH 计算机图形图像特别兴趣小组",
        en_utitle:
          "SIGGRAPH (Special Interest Group for Computer GRAPHICS), founded in 1967, has been devoted to the promotion and development of computer graphics and animation software and hardware technology. Since 1974, SIGGRAPH has held an annual conference, and since 1981 a CG (Computer Graphics) exhibition has been added. Most of the computer graphics software and hardware manufacturers will present their latest research results at SIGGRAPH every year, and most of the computer animation creators of games will showcase their most outstanding art works of the year at SIGGRAPH. Therefore, SIGGRAPH has a considerable influence on graphics and image technology, computer software and hardware, and CG.",
        utitle:
          "SIGGRAPH（Special Interest Group for Computer GRAPHICS，计算机图形图像特别兴趣小组）成立于1967年，一直致力于推广和发展计算机绘图和动画制作的软硬件技术。从1974年开始，SIGGRAPH每年都会举办一次年会，而从1981年开始每年的年会还增加了CG（Computer Graphics，电脑绘图）展览。绝大部分计算机图技术软硬件厂商每年都会将最新研究成果拿到SIGGRAPH年会上发布，大部分游戏的电脑动画创作者也将他们本年度最杰出的艺术作品集中在SIGGRAPH上展示。因此，SIGGRAPH在图形图像技术，计算机软硬件以及CG等方面都有着相当的影响力。",
      },
      {
        img: "http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20241213/SIGGRAPH asia.svg",
        title: "SIGGRAPH AISA",
        en_title: "SIGGRAPH AISA",
        en_utitle:
          "Siggraph Asia is the SIGGRAPH computer graphics and interactive technology exhibition and conference organized by the International Society of Graphics and Imaging. At present, SIGGRAPH generally refers to the conference in the United States. At present, the International Academic Ranking (hpca) of this conference is A+, and the hpca ranking of SIGGRAPH EuroGraphics (Europe) and SIGGRAPH Asia (Asia) are both A level. This is billed as one of the top three graphics conferences. Siggraph came to Asia in 2008. The first SIGGRAPHAsia Asia Computer Graphics and Interactive Technology Exhibition and Conference was held in Singapore from December 9 to 13. This is the first time that SIGGRAPH, the world's largest computer graphics and imaging event, chose to hold a chapter outside the United States. It is not only a big stage to review the rapid development of Asian CG industry in recent years, but also a highway for Asian CG to the world. SIGGRAPH Asia currently has two branches in China, Shenzhen and Shanghai.",
        utitle:
          "Siggraph Asia是由国际图形图像协会举办的SIGGRAPH电脑图像和互动技术展览及会议。现在的SIGGRAPH一般是指美国本土的会议，目前该会议的国际学术等级排名（hpca）为最顶级的A+，SIGGRAPH EuroGraphics（欧洲）和SIGGRAPH Asia（亚洲）的hpca排名都是A级，这号称是目前图形界三大顶级学会会议。2008年Siggraph来到亚洲，12月9日至13日首届SIGGRAPHAsia亚洲电脑图像和互动技术展览及会议在新加坡举行，这是世界最大的电脑图形图像界盛会SIGGRAPH首次选择在美国以外举办分会，既是检阅近几年亚洲CG行业飞速发展的大舞台，也是亚洲CG通往世界的高速公路。目前SIGGRAPH Asia在国内有深圳和上海有两个分会。",
      },
    ];
  }, 2000);
});
// 模拟更新背景图片
// setTimeout(() => {
//   state.aboutlist.banner.full_img = "https://example.com/new-image.jpg";
// }, 3000);

const topath = (e) => {
  router.push(e);
};
</script>
<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  z-index: 0;
  max-width: 1468px;
  margin: 0 auto;
  height: 500px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .banner {
    height: 100%;
    // position: absolute;
    // width: 100%;

    // top: 0;
    // bottom: 0;
    // background-image: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg");
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position: center center;
  }
}
.about {
  max-width: 1176px;
  margin: 0 auto;
  text-align: left;
  .thehome {
    margin: 28px 0 80px 0;
    @include fontstyle(#333, 14px, 400, auto);
  }
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    // white-space: pre-line;
    .one {
      text-align: center;
      display: inline-block;
      @include fontstyle(#333, 40px, 800, auto);
      line-height: 47px;
      margin-bottom: 48px;
      border-bottom: 8px solid #f4775e;
      padding-bottom: 3px;
    }
    .detail {
      @include fontstyle(#333, 16px, 400, auto);
      margin-bottom: 80px;
      line-height: 26px;
      width: 100%;
      // transition: all 1s;
      :nth-child(n) {
        // margin-bottom: 32px;
      }
    }
    .ACMtitle {
      text-align: left;
      font-weight: bold;
      font-size: 22px;
      color: #3657db;
      line-height: 26px;
      font-style: normal;
      margin-bottom: 16px;
      text-transform: none;
    }
    .ACMdetail {
      display: flex;
      // align-items: center;
      .uleft {
        // font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        // line-height: 26px;
        text-align: justify;
        // text-align: justified;
        margin-right: 95px;
        margin-bottom: 38px;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .about {
    padding: 30px;
  }
}
@media screen and (max-width: 768px) {
  .content {
    height: auto;
    .banner {
      width: 100%;
      height: auto;
    }
  }
  .two {
    width: 250px !important;
  }
  .about .title .ACMdetail {
    flex-direction: column-reverse;
    .uleft {
      margin-right: 0px;
    }

    .uimg {
      // text-align: center;
    }
  }
}
</style>
